import { ReactNode } from 'react';

import classnames from 'classnames';

import { ReactComponent as FilledLock } from './FilledLock.svg';
import styles from './FormHead.module.css';

export const FormHead = ({
  header,
  description,
  className,
  children,
}: {
  header: string;
  description: string;
  className?: string;
  children: ReactNode;
}) => {
  return (
    <div className={classnames(className)}>
      <div className={styles.inputHead}>
        <div className={styles.lock}>
          <FilledLock />
        </div>
        <div className={styles.headTitleVerticalLine} />
        <div className={styles.title}> {header} </div>
      </div>
      <div className={styles.soleTraderContainer}>
        <div className={styles.description}>{description}</div>
        <div className={styles.childComponentBody}>{children}</div>
      </div>
    </div>
  );
};
